import LayoutPadrao from 'lg-vue-components/layoutPadrao'

export default [
   {
      path: '/',
      redirect: 'bloqueio-subperiodos',
      component: LayoutPadrao,
      children: [
         {
            path: '/bloqueio-subperiodos',
            name: 'bloqueio-subperiodos',
            component: () => import('../pages/BloqueioSubperiodos.vue')
         }
      ]
   }
]
